import React from "react";
import "./index";
import "./style.scss";

import Navbar from "../navbar";
import Footer from "../footer";

// import FAQ from "react-faq-component";

import SEO from "../seo";
export default function About() {
  // const data = {
  //   // title: "FAQs (Frequently Asked Questions)",
  //   rows: [
  //     {
  //       title: "Lorem ipsum dolor sit amet,",
  //       content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sed tempor sem. Aenean vel turpis feugiat,
  //             ultricies metus at, consequat velit. Curabitur est nibh, varius in tellus nec, mattis pulvinar metus.
  //             In maximus cursus lorem, nec laoreet velit eleifend vel. Ut aliquet mauris tortor, sed egestas libero interdum vitae.
  //             Fusce sed commodo purus, at tempus turpis.`,
  //     },
  //     {
  //       title: "Nunc maximus, magna at ultricies elementum",
  //       content:
  //         "Nunc maximus, magna at ultricies elementum, risus turpis vulputate quam, vitae convallis ex tortor sed dolor.",
  //     },
  //     {
  //       title: "Curabitur laoreet, mauris vel blandit fringilla",
  //       content: `Curabitur laoreet, mauris vel blandit fringilla, leo elit rhoncus nunc, ac sagittis leo elit vel lorem.
  //           Fusce tempor lacus ut libero posuere viverra. Nunc velit dolor, tincidunt at varius vel, laoreet vel quam.
  //           Sed dolor urna, lobortis in arcu auctor, tincidunt mattis ante. Vivamus venenatis ultricies nibh in volutpat.
  //           Cras eu metus quis leo vestibulum feugiat nec sagittis lacus.Mauris vulputate arcu sed massa euismod dignissim. `,
  //     },
  //     {
  //       title: "Curabitur laoreet, mauris vel blandit fringilla",
  //       content: `Curabitur laoreet, mauris vel blandit fringilla, leo elit rhoncus nunc, ac sagittis leo elit vel lorem.
  //           Fusce tempor lacus ut libero posuere viverra. Nunc velit dolor, tincidunt at varius vel, laoreet vel quam.
  //           Sed dolor urna, lobortis in arcu auctor, tincidunt mattis ante. Vivamus venenatis ultricies nibh in volutpat.
  //           Cras eu metus quis leo vestibulum feugiat nec sagittis lacus.Mauris vulputate arcu sed massa euismod dignissim. `,
  //     },
  //   ],
  // };

  // const styles = {
  //   // bgColor: 'white',
  //   titleTextColor: "#082E51",
  //   rowTitleColor: "#082E51",
  //   rowContentColor: "grey",
  //   // arrowColor: "red",
  //   textAlign: "left",
  // };

  // const config = {
  //   animate: true,
  //   // arrowIcon: "V",
  //   // tabFocus: true
  // };

  return (
    <div className="about">
      <SEO
        title="About us | Eclipse International"
        description="Eclipse International is a leading American luxury Mattress brand that gives you a world-class sleep since 1905. Check out our ranges of Mattress and bed accessories."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-main.jpg"
      />
      <Navbar path="/about/" />
      <div className="about__content">
        <div className="about__history">
          <div className="about__history__container">
            <div className="row">
              <div className="col col-12 col-md-6">
                <div className="about__history__left">
                  <img
                    alt="Eclipse Text"
                    src="https://eclipsemattress.in/wp-content/themes/eclipse/images/text.png"
                  ></img>
                  <div>
                    Eclipse began in the 1890s when brothers Sam and Max
                    Weisglass emigrated their spring manufacturing business from
                    a small town outside of Ukraine to New York City.
                    <br />
                    <br />
                    In 1903, what began as Weisglass Spring Company, with hard
                    work and dedication, evolved into U.S. Cabinet and Bed
                    Company. Two years later, Eclipse Sleep Products was founded
                    and began to grow tremendously, eventually beccoming one of
                    the largest bedding companies on the east coast.
                    <br />
                    <br />
                    Times have changed and so has Eclipse. Today, with 21
                    factories servicing 6 continents, Eclipse still honors the
                    traditions upon which it was founded.
                  </div>
                </div>
              </div>
              <div className="col col-12 col-md-6">
                <div className="about__history__right">
                  <div style={{ textAlign: "center" }}>
                    <img
                      className="about__history__right__heading"
                      alt="history image"
                      src="https://eclipsemattress.in/wp-content/themes/eclipse/images/ourhistory.png"
                    ></img>
                  </div>
                  <div className="row">
                    <div
                      className="col-6 historyimg"
                      style={{ textAlign: "right" }}
                    >
                      <img
                        alt="history image"
                        src="https://eclipsemattress.in/wp-content/themes/eclipse/images/history1.jpg"
                      ></img>
                    </div>
                    <div
                      className="col-6 historyimg"
                      style={{ position: "relative" }}
                    >
                      <img
                        style={{ position: "absolute", top: "-18px" }}
                        alt="history image"
                        src="https://eclipsemattress.in/wp-content/themes/eclipse/images/history2.jpg"
                      ></img>
                    </div>

                    <div
                      className="col-6 historyimg"
                      style={{ textAlign: "right" }}
                    >
                      <img
                        alt="history image"
                        src="https://eclipsemattress.in/wp-content/themes/eclipse/images/history3.jpg"
                      ></img>
                    </div>
                    <div className="col-6 historyimg">
                      <img
                        alt="history image"
                        src="https://eclipsemattress.in/wp-content/themes/eclipse/images/history44.jpg"
                      ></img>
                    </div>
                    <div
                      className="col-6 historyimg"
                      style={{ textAlign: "right", position: "relative" }}
                    >
                      <img
                        style={{
                          position: "absolute",
                          top: "-52px",
                          right: "4px",
                        }}
                        alt="history image"
                        src="https://eclipsemattress.in/wp-content/themes/eclipse/images/history5.jpg"
                      ></img>
                    </div>
                    <div className="col-6 historyimg">
                      <img
                        alt="history image"
                        src="https://eclipsemattress.in/wp-content/themes/eclipse/images/history6.jpg"
                      ></img>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="about__section">
          <br />
          <br />
          <h1 className="heading-primary">MISSION</h1>
          <div className="mission">
            Our mission is to make a difference in the sleep health of our
            customers through handcrafting the highest quality sleep products.
            With a family legacy in the field of mattress manufacturing, our
            initial passion was to provide a range of products that greatly
            improved the lives of our customers. Ergonomics of sleep, as both an
            art and a science, a commitment to tradition, craft and luxury are
            all premium signatures that separate us from our competitors.
          </div>
          <br />
          <br />
          <div className="about__commitment">
            <h3 className="heading-secondary">Our Commitment</h3>
            <ul>
              <li>Top Notch Manufacturing Process, Design, and Materials</li>
              <li>Knowledgeable & Caring Dealer Support</li>
              <li>Quick & Accurate Shipments</li>
              <li>Carbon Footprint Conscious</li>
              <li>Charitable Contributions from Profits</li>
              <li>Listen with Open Ears to our Dealer Network</li>
            </ul>
          </div>
          <br />
          <br />

          <div className="about__team">
            <div className="row">
              <div className="col col-12 col-md-4">
                {" "}
                <img
                  className="about__team__img"
                  alt="stuart Carlitz"
                  src="https://eclipsemattress.in/wp-content/uploads/2019/10/leader_01.jpg"
                ></img>
              </div>
              <div className="col col-12 col-md-8">
                <div className="about__team__name">
                  Stuart Carlitz, Chief Executive Officer
                </div>

                <div className="about__team__description">
                  Stuart Carlitz has over thirty years of extensive marketing
                  and manufacturing experience in the bedding industry. He is
                  currently President and Chief Executive Officer of Bedding
                  Industries of America, a manufacturer of Eclipse, Eastman
                  House, and Therapedic Sleep Products. Prior to joining
                  Therapedic, Mr. Carlitz was Vice President of Englander Sleep
                  Products. Since that time, Mr. Carlitz has been instrumental
                  in the marketing and licensing of the Eclipse brand:
                  introducing new patents and technologies in manufacturing
                  sleep systems, and expanding the brand across the globe.
                </div>
              </div>
            </div>
          </div>

          <div className="about__bottomsection">
            <h3 className="heading-secondary">Top Notch Dealer Support</h3>
            <p className="about__quote">
              <em>
                “We work closely to support our dealer network to help deliver
                the highest quality customer experience”.
              </em>
            </p>
            <br />
            <br />

            <hr />
            <br />
            <br />
            <h3 className="heading-secondary">
              One Of The Largest Selling Global Mattress Brand
            </h3>
            <div className="row cities">
              <div className="col col-6 col-md-4 city">
                <h3 className="city__name">New Jersey</h3>
                1375 Jersey Avenue North Brunswick, NJ 08902
                <br />
                <br />
              </div>
              <div className="col col-6 col-md-4 city">
                <h3 className="city__name">California</h3>
                375 SW Ave. Fresno, CA 93706
                <br />
                <br />
              </div>
              <div className="col col-6 col-md-4 city">
                <h3 className="city__name">Korea</h3>
                Chungmyung-ro Youngtong-gu Suwon City Kyunggi-province, South
                Korea
                <br />
                <br />
              </div>
              <div className="col col-6 col-md-4 city">
                <h3 className="city__name">China</h3>
                Jingwu Building, No 5, Jiuxianqiao North Road, Chao Yang
                District, Beijing, China.
                <br />
                <br />
              </div>
              <div className="col col-6 col-md-4 city">
                <h3 className="city__name">Midwest</h3>
                3535 West 47th Street Chicago, IL 60632
                <br />
                <br />
              </div>
              <div className="col col-6 col-md-4 city">
                <h3 className="city__name">Victoria</h3>
                A.H. Beard Pty, Ltd. 49-53 Halsey Road Aiport West, VIC 3042
                <br />
                <br />
              </div>
            </div>
            {/* <div className="about__tech">
            <img src="https://eclipsemattress.in/wp-content/themes/eclipse/partner-img/allergylogo.jpg"></img>
            <img src="https://eclipsemattress.in/wp-content/themes/eclipse/partner-img/zonedquiltlogo.jpg"></img>
            <img src="https://eclipsemattress.in/wp-content/themes/eclipse/partner-img/spinalzonelogo.jpg"></img>
            <img src="https://eclipsemattress.in/wp-content/themes/eclipse/partner-img/natural.jpg"></img>
            <img src="https://eclipsemattress.in/wp-content/themes/eclipse/partner-img/lifeedgelogo.jpg"></img>
          </div> */}

            <div className="about__video">
              <iframe
                src="https://www.youtube.com/embed/jTef_4tC7z4"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          {/* <div className="about__faq">
            <h2 className="heading-primary">Frequently Asked Questions</h2>
            <FAQ data={data} styles={styles} config={config} />
          </div> */}
        </div>
        <Footer />
      </div>
    </div>
  );
}
